import { IClientInstallation, IUser } from '@api/models';
import http from 'httpConfig/http';
import { Label } from '@library/forms';
import { CircularProgress } from '@library/loaders/components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import React, { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { produce } from 'immer';
import { getResellerIdFromRedux } from 'modules/shared/helpers/shared.utils';
import { Button, Drawer } from '@hyperflake/react-ui-library';

interface IClientInstallationDeleteDrawerProps {
    open: boolean;
    onClose: () => void;
    clientInstallation: IClientInstallation | null;
}

const DeleteClientInstallationDrawer = (props: IClientInstallationDeleteDrawerProps) => {
    const { open, onClose, clientInstallation } = props;
    // const { clientInstaId } = useParams();
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const deleteClientMutation = useMutation(async (payload: any) => {
        const { data, status } = await http.delete(
            `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/client-installations/${
                clientInstallation._id
            }`
        );
        return { data, status };
    });

    const handleDelete = async () => {
        if (clientInstallation === null) return onClose();
        try {
            const { data, status } = await deleteClientMutation.mutateAsync({
                id: clientInstallation._id,
            });
            console.log({ data, status });
            toast.success('Client deleted Successfully.');
            // queryClient.setQueryData<IClientInstallation[]>(['client-installations'], (prev) => {
            //     if (!prev) return;

            //     const index = prev.findIndex((c) => c._id === clientInstallation._id);
            //     return produce(prev, (draft) => {
            //         draft.splice(index, 1);
            //         return draft;
            //     });
            // });
            onClose();
            navigate('/client-installations');
        } catch (ex: any) {
            onClose();
            console.log(ex.status);
            if (ex.status === 400) {
                toast.error(ex.data.message);
            } else {
                toast.error(ex?.data?.message || 'Some error occured, please try again.');
                console.log(ex);
            }
        }
    };

    return (
        <Drawer open={open} onClose={onClose} title="Confirm Delete">
            <div>
                <div>
                    <Label className="mt-8 inline-block">
                        The following client &ldquo;
                        <span className="font-bold">{clientInstallation?.name}</span>&rdquo; will be deleted.
                    </Label>

                    <div className="flex gap-2 mt-2">
                        <Button
                            disabled={deleteClientMutation.isLoading}
                            onClick={() => onClose()}
                            variant="default"
                            color={'primary'}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={deleteClientMutation.isLoading}
                            className="w-20"
                            onClick={() => handleDelete()}
                            variant="default"
                            color={'danger'}
                        >
                            {deleteClientMutation.isLoading ? <CircularProgress size={18} /> : 'Delete'}
                        </Button>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default DeleteClientInstallationDrawer;
